<div class="control product-chooser">
  <div class="products-grid">
    @for (group of productGroups; track group.variant) {
      <div class="group" [class.full-width]="group.options.length > 1">
        <div class="group-title">
          @if (group.iconURL) {
            <img class="group-title-icon" [src]="group.iconURL">
          }
          {{ group.variant }}
        </div>
        <div class="product-box">
          @for (option of group.options; track option.id) {
            <mat-option #matOpt
              [ngClass]='["product-chooser-option"]'
              [class.selected]="option.id === product?.id"
              [value]="option"
              [disabled]="!option.inStock"
              (click)="option.inStock && setCurrentProduct(option, matOpt)">
              <div class="option-name-price overlay"
                [ngClass]="{'disabled': !option.inStock}">
                <span class="name-size">
                  <span class="name">
                    {{ option.extraShortName }}
                  </span>
                  <span class="size">
                    {{ option.size }}
                  </span>
                </span>
                <span class="price">
                  <price-display
                    [price]="option.price"
                    [quantity]="1">
                  </price-display>
                </span>
              </div>
            </mat-option>
          }
        </div>
      </div>
    }
  </div>
</div>
